module.exports = __webpack_public_path__ + "static/media/HCRA Notice of Proposal re Compliance Order - Lynphyl Homes Ltd. - March 6, 2024.0eeda464.pdf";